import * as I from 'immutable';
import React from 'react';

import {ApiOrganization} from 'app/modules/Remote/Organization';

import {useOrgFeatureMetadata} from './hooks/useOrgFeatureMetadata';
import {FeatureMetadataApiResponse} from './types';
import {getLensStatsPercentLoaded} from './utils/chartUtils';

type FeatureMetadataProviderProps = {
  organization: I.ImmutableOf<ApiOrganization>;
  metadataFields?: string[];
  children: (props: {
    featureMetadata: FeatureMetadataApiResponse[] | undefined;
    isFetching: boolean;
    hasNextPage: boolean;
    fetchNextPage: () => void;
    isFetchingNextPage: boolean;
    error: Error | null;
    percentLoaded: number | undefined;
  }) => React.ReactNode;
};

export const FeatureMetadataProvider: React.FC<FeatureMetadataProviderProps> = ({
  organization,
  children,
  metadataFields = ['name', 'multiFeaturePartName'],
}) => {
  const {
    data: featureMetadata,
    isFetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    error,
  } = useOrgFeatureMetadata(organization.get('id'), metadataFields);

  const percentLoaded = React.useMemo(() => {
    return getLensStatsPercentLoaded(featureMetadata);
  }, [featureMetadata]);

  return (
    <>
      {children({
        featureMetadata,
        isFetching,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        error,
        percentLoaded,
      })}
    </>
  );
};
